import styles from "../Question/question.module.scss";
import { BsArrowLeftShort, BsArrowRightShort } from "react-icons/bs";
import { Button } from "cdhs-ui-library";
import { useTranslations } from "../../contexts/LanguageContext";


export interface NavigationButtonsProps {
    questionOrder?: number,
    isLoading: boolean
}

function NavigationButtons(props: NavigationButtonsProps) {
  const t = useTranslations();
  return (
 
    <div className={styles.buttonGroup}>
     {props.questionOrder !== undefined && Number(props.questionOrder) > 1 &&
      <Button
        caption={t('navigationButton_previous', 'Previous')}
        value="Previous"
        name="submitAction"
        variant="NYTD"
        mode="light"
        size="medium"
        fullWidth
        iconPosition="Left"
        image={<BsArrowLeftShort />}
        type="submit"
      />
    }
    <Button
      caption={t('navigationButton_next', 'Next')}
      value="Next"
      name="submitAction"
      variant="NYTD"
      size="medium"
      fullWidth
      iconPosition="Right"
      image={<BsArrowRightShort />}
      type="submit"
    />   

  </div>
  )
}

export default NavigationButtons